/// <reference path="ProductCategoryViewController.ts" />

class ProductCategoryListViewController extends ProductCategoryViewController
{
    viewDidLoad(){
        super.viewDidLoad();
        
        this.clearButton.hidden = true;

        MIONotificationCenter.defaultCenter().addObserver(this, "CategoryWillRemoveNotification", function (this:ProductCategoryListViewController, notification:MIONotification) {
            let category = notification.object as ProductCategory;
            if (category.identifier == this.selectedItem.identifier) {
                this.selectedItem = null;
                this.showNoItemSelected();
            }
        });                
    }

    didSelectedCategory(category:ProductCategory){
        super.didSelectedCategory(category);
        this.showItemDetail();
    }

    didCategoryAdded(category:ProductCategory){
        super.didCategoryAdded(category);
        this.showItemDetail();
    }

    private showItemDetail(){
        let vc = ProductCategoryDetailViewController.newInstance();
        vc.item = this.selectedItem;    
        this.splitViewController.showDetailViewController(vc);
    }

    private showNoItemSelected(){
        let vc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("ProductCategory", NoItemSelectedViewControllerType.ProductCategory);
        this.splitViewController.showDetailViewController(vc);
    }
}

